import type { FC } from "react";

import type { MarkdownToJSX } from "markdown-to-jsx";
import Markdown from "markdown-to-jsx";

export type MarkdownWrapperProps = {
  children: string;
  options?: MarkdownToJSX.Options;
};

export const MarkdownWrapper: FC<MarkdownWrapperProps> = ({ children = "", ...rest }) => {
  return <Markdown {...rest}>{children}</Markdown>;
};
